import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from '../../../reducers'
import { isDev } from '../server-data'
import { errorHandler } from './middlewares'

const configureStore = (initialStates) => {
  // TODO To optimize with webpack DefinePlugin to reduce code size
  const devToolsCompose =
    typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  const composeEnhancers = (isDev() && devToolsCompose) || compose
  const middlewares = [thunk, errorHandler()]

  if (isDev()) {
    middlewares.push(createLogger())
  }

  const store = createStore(
    rootReducer,
    initialStates,
    composeEnhancers(applyMiddleware(...middlewares)),
  )

  if (module.hot) {
    module.hot.accept('../../../reducers', () => {
      try {
        const newReducers = require('../../../reducers').default
        store.replaceReducer(newReducers)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`Reducer hot reloading error ${err}`)
      }
    })
  }

  return store
}

export { configureStore }
